import { CompanyFragment } from '@willow/graphql-iso/src/portal';

import { PaymentsPaused } from '../payments-paused/PaymentsPaused';

interface Props {
  company: CompanyFragment;
}

export const InactiveLoan = ({ company }: Props) => {
  return (
    <PaymentsPaused company={company} title="This loan is not active" subtitle="You do not have any payments due" />
  );
};
